import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const AtashsooziOmumiApiPaths: IPaths = {
  BimehNameh: {
    EstelamOmumi: 'BimehNameh/EstelamAtashSoozi',
    PrintBimehNamehAtashsooziOmumi: 'BimehNameh/PrintBimehNamehAtashsooziOmumi',
    GetPrintBimehNamehAtashsooziOmumiDisplay: 'BimehNameh/GetPrintBimehNamehAtashsooziOmumiDisplay',
    GetAllAtashsooziOmumiShomarehBimehNamehHa: 'BimehNameh/GetAllAtashsooziOmumiShomarehBimehNamehHa',
    GetAllAtashsooziOmumiBimehNamehHaPagedFilter: 'BimehNameh/GetAllAtashsooziOmumiBimehNamehHaPagedFilter',
    GetAtashsooziBimehNamehByShomarehBimehNameh: 'BimehNameh/GetAtashsooziBimehNamehByShomarehBimehNameh',
    CreateShenasehPardakht: 'BimehNameh/CreateShenasehPardakht',
    AddBimehNamehAtashsooziToOrderWepod: 'BimehNameh/AddBimehNamehAtashsooziToOrderWepod',
    BimehNamehAtashsooziSaderShodeh: 'BimehNameh/BimehNamehAtashsooziSaderShodeh',
    GetBimehNamehAtashsooziConfig: 'BimehNameh/GetBimehNamehAtashsooziConfig',
    PrintElhaghiyehAtashsoozi: 'BimehNameh/PrintElhaghiyehAtashsooziOmumi',
    GetElhaghiyehHayeSadereh: 'BimehNameh/GetElhaghiyehHayeSadereh',
    PrintBimehNamehAtashsooziById: 'BimehNameh/PrintBimehNamehAtashsooziById',
  },
  GoroohMoredBimeh: {
    GetActiveGoroohHayeMoredBimeh: 'GoroohMoredBimeh/GetActiveGoroohHayeMoredBimeh',
    GetGoroohMoredBimehPoosheshEzafi: 'GoroohMoredBimeh/GetGoroohMoredBimehPoosheshEzafi',
    GetPoosheshEzafiDetailByGoroohHayeMoredBimehCoreId:
      'GoroohMoredBimeh/GetPoosheshEzafiDetailByGoroohHayeMoredBimehCoreId',
    GetDescriptionsByNoeBimehNameh: 'GoroohMoredBimeh/GetDescriptionsByNoeBimehNameh',
  },
  NoeFaaliat: {
    GetActiveAnvaeFaaliatByNoeBimehNameh: 'NoeFaaliat/GetActiveAnvaeFaaliatByNoeBimehNameh',
  },
  PoosheshEzafi: {
    GetActivePoosheshHayeEzafi: 'PoosheshEzafi/GetActivePoosheshHayeEzafi',
    GetPoosheshHayeEzafiDetails: 'PoosheshEzafi/GetPoosheshHayeEzafiDetails',
    GetShowInSodoor: 'PoosheshEzafi/GetShowInSodoor',
  },
  NoeSazeh: {
    GetActiveAnvaeSazeh: 'NoeSazeh/GetActiveAnvaeSazeh',
  },
};
